// src/App.js
import React from 'react';
import useMeta from '../../hooks/useMeta';

import Navbar from '../../CommonComponent/Navbar/Navbar'; // Importing the Navbar component
import Footer from '../../CommonComponent/Footer/footer';
import NotificationBar from '../../CommonComponent/Notification/NotificationBar';


//page component

import LCPcontent from './PageComponent/LCPcontent'


function LCP() {

    useMeta({
        title: 'Light Control & Privacy | Callistus Blinds',
        description: 'Discover premium window treatments at Callistus Blinds. Explore our extensive range of stylish blinds and shades to enhance your home’s aesthetic and comfort.',
        canonical: 'https://callistusblinds.com/light-control-privacy/',
        og: {
            locale: 'en_US',
            type: 'article',
            title: 'Light Control & Privacy | Callistus Blinds',
            description:
                'Discover premium window treatments at Callistus Blinds. Explore our extensive range of stylish blinds and shades to enhance your home’s aesthetic and comfort.',
            url: 'https://callistusblinds.com/light-control-privacy/',
            site_name: 'Callistus Blinds',
        },
    });

    return (
        <div>
            <Navbar />
            <NotificationBar />
            <LCPcontent />
            <Footer />
        </div>
    );
}

export default LCP;
